/**
 * DOM manipulation utilities
 */

/**
 * Set the height of content area elements
 */
export function setContentHeight() {
  const h = jQuery('#content-section').height() - 20;
  jQuery('.content-full-height').height(h);
}

/**
 * Fit text to container width by dynamically adjusting font size
 * @param {string} selector - CSS selector for elements to fit
 * @param {number} minFontSize - Minimum font size in pixels (default: 10)
 * @param {number} maxFontSize - Maximum font size in pixels (default: 16)
 */
export function fitTextToContainer(selector, minFontSize = 10, maxFontSize = 16) {
  const elements = document.querySelectorAll(selector);

  elements.forEach((el) => {
    // Reset to max font size first
    el.style.fontSize = `${maxFontSize}px`;

    // Get the parent container width
    const containerWidth = el.parentElement ? el.parentElement.clientWidth : el.clientWidth;

    // Reduce font size until text fits or we hit minimum
    let currentSize = maxFontSize;
    while (el.scrollWidth > containerWidth && currentSize > minFontSize) {
      currentSize -= 0.5;
      el.style.fontSize = `${currentSize}px`;
    }
  });
}

/**
 * Initialize text fitting for sensor names and set up resize handler
 */
export function initSensorNameFitting() {
  // Fit text on initial load
  fitTextToContainer('.sensor-name', 10, 16);
  fitTextToContainer('.sensor-name-leak', 8, 13);

  // Debounced resize handler
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      fitTextToContainer('.sensor-name', 10, 16);
      fitTextToContainer('.sensor-name-leak', 8, 13);
    }, 150);
  });
}

/**
 * Sort chores by due time and preserve original indices
 * @param {Array} chores - Array of chore objects
 * @returns {Array} Sorted chores with originalIndex property
 */
export function sortChoresWithIndex(chores) {
  // If no chores, return empty array
  if (!chores || chores.length === 0) {
    return [];
  }

  // Sort by dueTime if it exists, otherwise by name, otherwise keep original order
  const sorted = chores.slice().sort((a, b) => {
    if (a.dueTime && b.dueTime) {
      return a.dueTime.localeCompare(b.dueTime);
    } else if (a.name && b.name) {
      return a.name.localeCompare(b.name);
    }
    return 0;
  });

  return sorted.map((chore) => {
    return {
      chore: chore,
      originalIndex: chores.indexOf(chore),
    };
  });
}

/**
 * Separate chores into completed and incomplete arrays
 * @param {Array} sortedChoresWithIndex - Sorted chores with indices
 * @returns {object} Object with incomplete and completed arrays
 */
export function separateChoresByCompletion(sortedChoresWithIndex) {
  const incomplete = [];
  const completed = [];

  sortedChoresWithIndex.forEach((item) => {
    if (item.chore.completed) {
      completed.push(item);
    } else {
      incomplete.push(item);
    }
  });

  return { incomplete, completed };
}
